const InitiateRouter = {
    path: '/initiate', 
    name: 'initiate',
    component: () => import("@/views/initiate/home.vue"),
    children: [
        {
            path: 'idea',
            name: 'idea',
            meta: {title: '发布创意 - 摩点 - 发现新奇好物'},
            component: () => import('@/views/initiate/idea.vue')
        },
        {
            path: 'idea_update',
            name: 'idea_update',
            meta: {title: '更新创意 - 摩点 - 发现新奇好物'},
            component: () => import('@/views/initiate/idea.vue')
        },
        {
            path: 'idea_edit',
            name: 'idea_edit',
            meta: {title: '编辑创意 - 摩点 - 发现新奇好物'},
            component: () => import('@/views/initiate/idea.vue')
        },
        {
            path: 'base',
            name: 'initiate_base',
            meta: {title: '发起项目 - 摩点 - 发现新奇好物'},
            component: () => import('@/views/initiate/base.vue')
        },
        {
            path: 'detail',
            name: 'initiate_detail',
            meta: {title: '发起项目 - 摩点 - 发现新奇好物'},
            component: () => import('@/views/initiate/detail.vue')
        },
        {
            path: 'reward',
            name: 'initiate_reward',
            meta: {title: '发起项目 - 摩点 - 发现新奇好物'},
            component: () => import('@/views/initiate/reward.vue')
        },
    ]
}

export default InitiateRouter
